import { sortAlpha } from "helpers/arrays";
import { IOrganizationAccount, IOrganizationItem } from "model/organizations";
import {
  getAllowedAccounts,
  getOrgsWithAllowedAccounts,
} from "./allowedAccountsHelper";
import {
  getAccountsByOrganizationId,
  getUserOrganizations,
} from "./orgAsyncActions";
import { IAuthError, IAuthState } from "./types";

//async thunk actions reducers
export function applyOrganizationExtraReducers(builder) {
  builder.addCase(
    getUserOrganizations.fulfilled,
    (state: IAuthState, { payload }) => {
      const orgs = (
        Array.isArray(payload) ? payload : []
      ) as IOrganizationItem[];
      const sortedOrgs = orgs.sort(({ name: a }, { name: b }) =>
        sortAlpha(a, b)
      );
      const orgsWithAllowedAccounts = getOrgsWithAllowedAccounts(
        sortedOrgs,
        state.canAccessAnyAccount,
        state.userAccessibleAccountIds
      );

      state.organizations = orgsWithAllowedAccounts;
    }
  );

  builder.addCase(
    getAccountsByOrganizationId.fulfilled,
    (
      state: IAuthState,
      {
        payload,
      }: {
        payload: {
          accounts?: IOrganizationAccount[];
          organizationId: string;
        };
      }
    ) => {
      const updatedOrganization = state.organizations.find(
        (o) => o.id === payload.organizationId
      );
      if (updatedOrganization) {
        updatedOrganization.accounts = getAllowedAccounts(
          payload.accounts,
          state.canAccessAnyAccount,
          state.userAccessibleAccountIds
        );
      }
    }
  );

  builder.addCase(getUserOrganizations.rejected, (state, action) => {
    state.orgSwitchError = `Failed to load organizations: ${
      action.error?.message || "unknown error"
    }`;
  });
}

//actions reducers
export const organizationReducers = {
  setInitialOrgAndAcc(
    state,
    action: { payload: { organizationId: string; accountId: string } }
  ) {
    state.organizationId = action.payload.organizationId;
    state.accountId = action.payload.accountId;
  },
  setOrgSwitchError(state, action: { payload: string }) {
    state.orgSwitchError = action.payload;
  },
  setError(state, { payload }: { payload: IAuthError }) {
    state = { ...state, ...payload };
  },
};
